import { useState } from "react";
import { fetchKvKInfo } from "../utils/authApiHelpers";

export function useKvKLookup(setFormData, showFlash, isCustomerForm = false) {
    const [kvkError, setKvkError] = useState("");
    const [loadingKvk, setLoadingKvk] = useState(false);
    const validateKvK = (kvk) => /^\d{8}$/.test(kvk);

    const fetchKvKData = async (kvkNumber) => {
        if (!kvkNumber) return;
        if (!validateKvK(kvkNumber)) {
            setKvkError("Ongeldig KvK-nummer (8 cijfers vereist)");
            return;
        } else {
            setKvkError("");
        }
        setLoadingKvk(true);
        try {
            const response = await fetchKvKInfo(kvkNumber);
            if (response.status === 404) {
                setKvkError("KvK-nummer niet gevonden.");
                if (showFlash) showFlash("KvK-nummer niet gevonden.", "error");
                setLoadingKvk(false);
                return;
            }
            if (response.status !== 200) throw new Error("KvK-nummer ongeldig of niet gevonden.");
            const company = response.data._embedded.hoofdvestiging;
            const adres = company.adressen[0];
            if (company) {
                if (isCustomerForm) {
                    // For customer forms, map to customer fields
                    setFormData(prev => ({
                        ...prev,
                        name: company.eersteHandelsnaam || "",
                        address: `${adres.straatnaam} ${adres.huisnummer}, ${adres.postcode} ${adres.plaats}`
                    }));
                } else {
                    // For user/employee forms, map to company_name
                    setFormData(prev => ({
                        ...prev,
                        company_name: company.eersteHandelsnaam || "",
                        address: `${adres.postcode} ${adres.plaats} - ${adres.straatnaam} ${adres.huisnummer}`
                    }));
                }
            }
        } catch (err) {
            if (err.status === 404) {
                if (showFlash) showFlash("KvK-nummer niet gevonden.", "error");
                setKvkError("KvK-nummer niet gevonden.");
            } else {
                if (showFlash) showFlash("Fout bij ophalen KvK-Gegevens.", "error");
            }
        } finally {
            setLoadingKvk(false);
        }
    };

    return { kvkError, setKvkError, loadingKvk, fetchKvKData };
}
